'use strict';

angular.module('programme')

.directive('carouselVideo', function ()
{
    return {
        restrict: 'A',
        replace: true,
        templateUrl: 'modules/programme/editor-components/carousel-video/carouselVideo.html',
        controller: 'carouselVideoCtrl',
        controllerAs: '$ctrl',
    };
})

.controller('carouselVideoCtrl', function ($scope, $element, assetCache, $sce)
{
    $scope.data.asset_id = $scope.data.asset_id || 0;
    $scope.data.poster_id = $scope.data.poster_id || 0;

    var self = this;

    this.config = {
        sources: [],
        tracks: [
            {
                src: "http://www.videogular.com/assets/subs/pale-blue-dot.vtt",
                kind: "subtitles",
                srclang: "en",
                label: "English",
                default: ""
            }
        ],
        theme: "components/videogular-themes-default/videogular.css",
        plugins: {
            poster: null
        }
    };

    $scope.$watch('data.poster_id', function ()
    {
        if (!$scope.data.poster_id) {
            self.config.plugins.poster = null;
            return;
        }

        assetCache.get($scope.data.poster_id).then(function (asset)
        {
            self.config.plugins.poster = asset.links.download;
        });
    });

    $scope.$watch('data.asset_id', function ()
    {
        if (!$scope.data.asset_id) {
            self.config.sources = [];
            return;
        }
        assetCache.get($scope.data.asset_id).then(function (asset) {
            self.config.sources = [];

            if (asset.links.mp4) {
                self.config.sources.push(
                    {
                        src: $sce.trustAsResourceUrl(asset.links.mp4),
                        type: "video/mp4"
                    }
                );
            }
            if (asset.links.webm) {
                self.config.sources.push(
                    {
                        src: $sce.trustAsResourceUrl(asset.links.webm),
                        type: "video/webm"
                    }
                );
            }
        });
    });
});
